// extracted by mini-css-extract-plugin
module.exports = {"main":"regularparentpermit_main__tgtMk","newlogo":"regularparentpermit_newlogo__1rCne","logoDiv":"regularparentpermit_logoDiv__e2DgB","text":"regularparentpermit_text__S2CTN"};